import { useMemo } from 'react';

import { ClientDataType } from '../../../types';

export const useUserAndEventFieldFacetsVariables = (dataType: ClientDataType, field: string) =>
  useMemo(
    () => ({
      dataType,
      field,
    }),
    [dataType, field],
  );
